/*global define*/

define([
    'underscore',
    'backbone',
    './Vessel',
    './Tool',
    '../views/Vessel',
    '../collections/Vessel',
    '../collections/Tool',
    '../resources/vessels',
    '../resources/tools',
    'postal'
], function (_, Backbone, VesselModel, ToolModel, VesselView, VesselCollection, ToolCollection, vessels, tools, postal) {
    'use strict';
    var vls= new VesselCollection();
    var tls = new ToolCollection();
    var WorkbenchModel = Backbone.Model.extend({
        defaults: {
            app: undefined,
            vesselCollection: vls,
            toolCollection: tls,
            currentVesselCid: undefined,
            vesselViews: {},
            toolViews: {},
            displayName: "New Workbench"
        },
        initialize: function(){
        },
        addSolution: function(solution, vessel){
            var vesselCollection = this.get('vesselCollection');
            var vslObj = vessels[vessel.replace(/_| /g, '')];
            var newVessel = new VesselModel(solution, vslObj);
            try {
                vesselCollection.add(newVessel);
                this.set('vesselCollection', vesselCollection);
                this.set('currentVesselCid', newVessel.cid);
            }
            catch (error) {
                this.deleteVessel(error);
            }
        },
        addTool: function(tool){
            var toolCollection = this.get("toolCollection");
            var toolObject = tools[tool];
            var newTool = new ToolModel(toolObject);
            try {
                toolCollection.add(newTool);
                this.set("toolCollection", toolCollection);
            }
            catch (error) {
                this.deleteTool(error);
            }
        },
        toJSON: function(){
        	return {'cid': this.cid,
                    'name': this.get('displayName')}
        },
        deleteVessel: function(vesselCid){
            var removeVsl = this.get('vesselCollection').get(vesselCid);

            removeVsl.destroy();
            this.get('vesselViews')[vesselCid].remove();
            this.get('vesselViews')[vesselCid].unbind();
            delete this.get('vesselViews')[vesselCid];
        },
        deleteTool: function(toolCid){
            var removeTool = this.get("toolCollection").get(toolCid);
            removeTool.destroy();
            this.get("toolViews")[toolCid].remove();
            this.get("toolViews")[toolCid].unbind();
            delete this.get("toolViews")[toolCid];
        },
        pour: function(pourFromCid, pourToCid, amount){
            var pourFromVsl = this.get('vesselCollection').get(pourFromCid);
            var pourToVsl = this.get('vesselCollection').get(pourToCid);
            var original = pourToVsl.get("solution").clone();
            pourToVsl.addSolution(pourFromVsl, amount/1000);
            pourFromVsl.removeVolume(amount/1000);
            var source = pourToVsl.get("solution");
            var logger = postal.channel("logger");
            logger.publish("solutionChanged", {source: source, original: original, other: pourFromVsl.get("solution"), volumeRequested: amount / 1000, eventType: "MIX"});
            var scale = postal.channel("scale");
            scale.publish("weightChanged_"+pourToCid, {difference: source.getSolutionWeight() - original.getSolutionWeight()});
            this.set("currentVesselCid", pourToCid);
            var instrumentPanel = this.get("app").get("instrumentPanelView");
            instrumentPanel.update(pourToVsl);
        }
    });
    return WorkbenchModel;
});
